import React, { useState, useEffect, useContext } from 'react';
import { Button } from 'react-bootstrap';
import { getContent } from '../api';
import MainImage from '../components/MainImageEdit';
import AboutEdit from '../components/AboutEdit';
import ServicesEdit from '../components/ServicesEdit';
import NewsEdit from '../components/NewsEdit';
import ContactsEdit from '../components/ContactsEdit';
import LogoEdit from '../components/LogoEdit';
import PasswordEdit from '../components/PasswordEdit';
import NavBarEdit from '../components/NavBarEdit';
import adminContext from '../context/adminContext';
import Loading from '../components/Loading';

function BackOffice() {
  const [about, setAbout] = useState(null);
  const [services, setServices] = useState(null);
  const [news, setNews] = useState(null);
  const [contacts, setContacts] = useState(null);
  const [pictures, setPictures] = useState(null);
  const [state, setState] = useState('loading');

  const { setUserData } = useContext(adminContext);

  useEffect(() => {
    getContent()
      .then((res) => {
        setAbout(res.data.about);
        setServices(res.data.services);
        setNews(res.data.news);
        setContacts(res.data.contacts);
        setPictures(res.data.main);
        setState('success');
      })
      .catch();
  }, []);

  const logout = () => {
    setUserData({
      token: 'INVALID',
      userId: 'INVALID',
    });
    localStorage.setItem('auth-token', '');
    window.location.href = '/';
  };

  if (state === 'loading') {
    return (
      <Loading />
    );
  }

  return (
    <div>
      {pictures && <NavBarEdit logo={pictures[1].image} />}
      <div className="backoffice">
        {pictures && <MainImage Main={pictures} />}
        <div className="settings">
          {about && <AboutEdit About={about} />}
          {services && <ServicesEdit Services={services} />}
          {news && <NewsEdit News={news} />}
          {contacts && <ContactsEdit Contacts={contacts} />}
          {pictures && <LogoEdit Main={pictures} />}
          {<PasswordEdit />}
          <div id="logout" className="d-flex justify-content-end" style={{ margin: '2em' }}>
            <Button
              variant="red btn-custom"
              onKeyPress={logout}
              onClick={logout}
            >
              Logout
            </Button>
          </div>
        </div>
      </div>
    </div>

  );
}
export default BackOffice;
